export const FONT_SIZES = {
  X_SMALL: "xsmall",
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
  X_LARGE: "xlarge",
  XX_LARGE: "xxlarge",
  XXX_LARGE: "xxxlarge",
};

export const fontSizes = {
  [FONT_SIZES.X_SMALL]: "7px",
  [FONT_SIZES.SMALL]: "12px",
  [FONT_SIZES.MEDIUM]: "14px",
  [FONT_SIZES.LARGE]: "16px",
  [FONT_SIZES.X_LARGE]: "20px",
  [FONT_SIZES.XX_LARGE]: "32px",
  [FONT_SIZES.XXX_LARGE]: "48px",
};
